import type { SVGProps } from "react";
const SvgUniversity = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.25}
      d="M1.667 18.333h16.25M2.5 10.833v7.5m15-7.5v7.5M6.25 6.667v11.666m7.5-11.666v11.666M1.667 10.833h4.166m12.5 0h-4.166M5.417 6.667h9.166M10 6.667V4.152m0 0V2.475c0-.395 0-.592.122-.715.383-.386 1.961.526 2.562.895.506.313.65.936.65 1.497zM10 18.333v-1.666M8.75 10v.417m2.5-.417v.417M8.75 13.333v.417m2.5-.417v.417"
    />
  </svg>
);
export default SvgUniversity;
